import React, { Fragment } from 'react'
import { useSelector } from 'react-redux';
import { Polygon } from "react-google-maps";
import { FindCenterPointPolygon } from '../../../Containers/GiaoCatPolygons';

const PolyGonQuyHoach = (props) => {
    const { polygons, opacityLevel, labelActive } = useSelector(state => state.quyHoach);
    const onPolygonPress = (e) => {
        props.onClickEvnt(e)
    }
    return (
        <Fragment>
            {
                polygons.map((e, index) => {
                    if (e.diadanh && e.diadanh !== " ") {
                        // e['polygon']
                        // FindCenterPointPolygon()
                    }
                    return (
                        <Polygon
                            key={e.ID}
                            paths={e['polygon']}
                            defaultPath={[]}
                            options={{
                                strokeColor: e.strokeColor,
                                fillColor: e.fillColor || e.strokeColor,  // (e.strokeColor === "#fff" ? 'transparent' : e.strokeColor),
                                strokeWeight: e.weightLine,
                                zIndex: opacityLevel === 0 ? 1 : 500,
                                fillOpacity: opacityLevel
                            }}

                            visible={labelActive.includes(e['label'])}
                            onClick={() => onPolygonPress(e)}
                        />

                    )

                })
            }
        </Fragment>
    )
}

export default React.memo(PolyGonQuyHoach)